import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-input-cell-editor',
    template: `
    <div class="custom-renderer-ag">
         <input type="text" class="form-control form-ctrl" style="border-bottom: inherit !important;" [disabled]="params.node.data.isAmountPercentDisabled" [(ngModel)]="selectedValue" (ngModelChange)="onValueChange($event)" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57 &&  (!event.target.value || !event.target.value.split('.')[1] ||  (event.target.value.split('.')[1]).length<6) ) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)">
</div>
  `,
})
export class AmountPercentInputCellRenderer implements ICellEditorAngularComp {
    params: any;
    public selectedValue: number;

    agInit(params: any): void {
        this.params = params;
        this.selectedValue = params.value;
    }
    
    refresh(params: any) {
        this.params = params;
        this.selectedValue = params.value;
        return true;
    }

    getValue(): number {
        return this.selectedValue;
    }

    isPopup(): boolean {
        return true; // Return true if you want popup editing style
    }

    // Optional methods
    // You can add additional methods like focusIn, focusOut, etc. as needed

    onValueChange(newValue: number): void {
        this.params.setValue(newValue);
    }

    // Implement other necessary methods from ICellEditorAngularComp interface
}
